import React, { useEffect, useRef, useState } from "react";
import { Popup } from "devextreme-react/popup";
import { useScreenSize } from "../../utils/media-query";
import { Button } from "devextreme-react";
import "./CustomOtpPopup.scss";
import CustomTextBox from "../customTextBox/CustomTextBox";
import CustomButton from "../customButton/CustomButton";
import "./CustomChangePwdPopup.scss";
import { useAuth } from "../../contexts/auth";
import { ToastDisplayer } from "../toastDisplay/ToastDisplayer";
import {
  generateOtpWithAction,
  resetPwd,
  updPwdReq,
  verifyOtp,
} from "../../api/forgotPwdApi";

const CustomChangePwdPopup = ({
  visible,
  onClose,
  title = "Verify an OTP",
  height = 250,
  setLoading,
  loading,
}) => {
  const { user, signOut } = useAuth();
  const screensizes = useScreenSize();
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const inputRefs = useRef([]);
  const length = 6;
  const [timer, setTimer] = useState(120);
  const minutes = Math.floor(timer / 60);
  const seconds = timer % 60;
  const [verified, setVerified] = useState(false);
  const [newPassword, setNewPassword] = useState("");

  const handleChange = (index, e) => {
    const value = e.target.value;
    if (isNaN(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value.substring(value.length - 1);
    setOtp(newOtp);

    const combinedOtp = newOtp.join("");
    if (combinedOtp.length === length) onOtpSubmit(combinedOtp);

    if (value && index < length - 1 && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1].focus();
    }
  };

  const onOtpSubmit = async (combinedOtp) => {
    try {
      setLoading(true);
      const result = await verifyOtp(user?.email, "R", combinedOtp);

      if (result?.status === 200 && result?.data) {
        ToastDisplayer("success", result.data.message);
        setVerified(true);
      }
    } catch (error) {
      ToastDisplayer(
        "error",
        error.response?.data?.error || "An unexpected error occurred.",
      );
    } finally {
      setLoading(false);
      // setOtp(new Array(6).fill(""))
    }
  };

  useEffect(() => {
    if (!visible) return;

    const interval = setInterval(() => {
      setTimer((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(interval);
  }, [visible]);

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && index > 0 && otp[index] === "") {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleRetryClick = async () => {
    try {
      setLoading(true);

      const otpResult = await generateOtpWithAction(user.email, "R");

      ToastDisplayer(
        otpResult?.status === 200 ? "success" : "error",
        otpResult?.status === 200
          ? otpResult.data.message
          : "OTP generation failed",
      );

      if (otpResult?.status === 200) {
        setOtp(new Array(length).fill(""));

        if (inputRefs.current[0]) {
          inputRefs.current[0].focus();
        }
        setTimer(0);
        setTimeout(() => setTimer(120), 0);
      }
    } catch (error) {
      ToastDisplayer("error", error.response?.data?.error || error.message);
    } finally {
      setLoading(false);
    }
  };

  const handlePwdContinue = async () => {
    try {
      setLoading(true);
      const result = await resetPwd(user.email, newPassword);
      if (result?.status === 200 && result?.data) {
        ToastDisplayer("success", result.data.message);
        signOut();
      }
    } catch (error) {
      ToastDisplayer(
        "error",
        error.response?.data?.error || "An unexpected error occurred.",
      );
    } finally {
      setLoading(false);
    }
  };

  const handlePopupPwdCancel = () => {
    setOtp(new Array(length).fill(""));
    onClose();
  };

  return (
    <Popup
      onShown={() => {
        if (inputRefs.current[0]) {
          inputRefs.current[0].focus();
        }
      }}
      visible={visible}
      onHiding={onClose}
      height={height}
      width={"auto"}
      showCloseButton={false}
      dragEnabled={false}
      showTitle={false}
      className="import-popup"
    >
      <div className="import-popup-main-container">
        <div className="import-popup-header">
          <div className="import-popup-header-title">
            <div className="header-text">{title}</div>
            <div className="sub-text">
              {verified ? (
                <div className="resetTextPopup">
                  You need to log in again using the new password.
                </div>
              ) : (
                <div className="resetText">
                  Sent to {user.email}{" "}
                  <span className="notyouText" onClick={handlePopupPwdCancel}>
                    Not you?
                  </span>{" "}
                </div>
              )}
            </div>
          </div>

          <div className="popup-close-btn">
            <Button icon="close" onClick={handlePopupPwdCancel} />
          </div>
        </div>

        {verified ? (
          <>
            <CustomTextBox
              label="New Password"
              placeholder="Set your new password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.value)}
              type="password"
            />

            <div className="btnSectionPopup">
              <div className="cancelSectionPopUp">
                <Button
                  text="Cancel"
                  height={"40px"}
                  width={"100%"}
                  onClick={handlePopupPwdCancel}
                />
              </div>

              <div className="create-button-popup">
                <CustomButton text={"Continue"} onClick={handlePwdContinue} />
              </div>
            </div>
          </>
        ) : (
          <div>
            <div className="main-container1">
              <div className="otp-main">
                {otp.map((value, index) => (
                  <input
                    key={index}
                    type="text"
                    ref={(input) => (inputRefs.current[index] = input)}
                    value={value}
                    onChange={(e) => handleChange(index, e)}
                    onKeyDown={(e) => handleKeyDown(index, e)}
                    className="otpInput"
                  />
                ))}
              </div>
            </div>

            <div className="footer-main">
              <span className="Pre-text">
                {timer > 0 ? (
                  <>
                    Didn't get an OTP ?
                    <span className="boldText">
                      Retry in {minutes.toString().padStart(2, "0")} :{" "}
                      {seconds.toString().padStart(2, "0")}
                    </span>
                  </>
                ) : (
                  "Didn’t get an OTP ?"
                )}
                {timer === 0 && (
                  <span className="resendTxt" onClick={handleRetryClick}>
                    Click here to resend
                  </span>
                )}
              </span>
            </div>
          </div>
        )}
      </div>
    </Popup>
  );
};

export default CustomChangePwdPopup;
